import { show, hide } from 'redux-modal'
import { rest } from 'services'
import { EDIT_MILEAGE_MODAL } from './constants'

export const showEditMileageModal = ({ userVehicleId }) => async (dispatch) =>
  rest.api.getMileageDetails({ userVehicleId })
    .then(({ displayMileage, displayCurrentMileage }) => {
      dispatch(show(EDIT_MILEAGE_MODAL, { mileage: displayMileage, userVehicleId, displayCurrentMileage }))
    })
    .catch(err => console.error(err))

export const hideEditMileageModal = () => hide(EDIT_MILEAGE_MODAL)

export const showEditMileageModalPerDay = ({ userVehicleId }) => dispatch => {
  const storageDate = localStorage.getItem('date')
  const storageVehicleId = JSON.parse(localStorage.getItem('editMileageModalVehicleIds')) || []
  const vehicleIdIsEqual = storageVehicleId.find(item => item === userVehicleId)
  const currentDate = new Date().toDateString()
  const dateIsNotEqual = storageDate !== currentDate
  localStorage.setItem('date', currentDate)

  if (dateIsNotEqual || !vehicleIdIsEqual) {
    const isVehicleIdDuplicate = storageVehicleId.find(item => item === userVehicleId)
    if (!isVehicleIdDuplicate) {
      localStorage.setItem('editMileageModalVehicleIds', JSON.stringify([...storageVehicleId, userVehicleId]))
    }
    dispatch(showEditMileageModal({ userVehicleId }))
  }
}
